import React, { useEffect } from 'react'
import { getCurrentUserName, useOnlineStateSnapshot } from 'store/storeValtio'
import addIcon from 'icons/plus-circle-24.png';
import HelpButton from 'components/help/HelpButton';

export default function Header({title, help, add}) {
  //console.log('Header');
  const currentUserName = getCurrentUserName();
  const os = useOnlineStateSnapshot();

  useEffect(()=>{
    //console.log('Header UE', os.online);
    console.log( os.online ? "online" : "offline");
  }, [os.online])

  function addItem() {
    if (add) add();
  }

  return (
    <div className='mcard-screen flex justify-between'>
    <div>{title}</div>
    <div className='text-lg font-normal'>{currentUserName}</div>
    <div>{os.online ? '!' : '?'}</div>
    {add && 
      <img 
        className='w-10 hover:cursor-pointer' 
        src={addIcon} 
        onClick={()=>addItem()} alt=""
      />
    }
    {help && 
      <HelpButton helpType={help} />
    }

  </div>
)
}

